import React, { useState } from "react";
import { Container } from "..";
import { Accordion } from "../../../../../app/components";
import CustomCell from "../../../../../app/components/custom.tables.components/custom.cell";
import CustomRow from "../../../../../app/components/custom.tables.components/custom.row";
import EditNotesInput from "../edit.notes.input";
import CustomTooltip from "../../../../../app/components/tooltip/custom.tooltip";
import { useRestoreTableVisibility } from "../../hooks/useRestoreTableVisibility";
import { DATA_TABLE_NAME } from "../../constants";
import { toParticipantUiText } from "../../../../../app/utils/participantTerminology";

const HEADER_DATA = [
  { width: "30%", label: "" },
  { width: "10%", label: "100% (traditional)" },
  { width: "10%", label: "Visit Sampling Modeling" },
  { width: "10%", label: "Difference from Traditional" },
  { width: "40%", label: "Notes" },
];

export default function CRATable({ data, readOnly }) {
  const [editState, setEditState] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);

  useRestoreTableVisibility('CRATable', setIsExpanded);

  const renderHeader = () => (
    <CustomRow>
      {HEADER_DATA.map((col, idx) => (
        <CustomCell
          key={idx}
          variant="header"
          width={col.width}
          style={col.width === "30%" ? { borderBottom: "none" } : {}}
        >
          {col.label}
        </CustomCell>
      ))}
    </CustomRow>
  );

  const renderRows = () => {
    return data.map((d, idx) => {
      const isLastRow = idx === data.length - 1;
      return (
        <CustomRow
          style={{ borderBottom: isLastRow ? "none" : undefined }}
          key={idx}
        >
          <CustomCell
            variant="header"
            justify="flex-end"
            width={HEADER_DATA[0].width}
            textAlign="right"
            style={{
              borderBottom: "none",
              borderBottomLeftRadius: isLastRow ? "8px" : undefined,
            }}
          >
            {toParticipantUiText(d.rowLabel)}
          </CustomCell>
          <CustomCell width={HEADER_DATA[1].width}>
            <CustomTooltip title={d.cellValue1?.toString() || ''}>
              <div>{d.cellValue1}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={HEADER_DATA[2].width}>
            <CustomTooltip title={d.cellValue2?.toString() || ''}>
              <div>{d.cellValue2}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={HEADER_DATA[3].width}>
            <CustomTooltip title={d.cellValue3?.toString() || ''}>
              <div>{d.cellValue3}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell
            style={{
              position: "relative",
              borderBottomRightRadius: isLastRow ? "8px" : undefined,
            }}
            textAlign="left"
            justify="flex-start"
            width={HEADER_DATA[4].width}
          >
            <EditNotesInput
              d={d}
              editState={editState}
              setEditState={setEditState}
              readOnly={readOnly}
            />
          </CustomCell>
        </CustomRow>
      );
    });
  };

  return (
    <Accordion
      scrollIntoView={true}
      width={"100%"}
      summary={"CRA Time - SDR/SDV Time"}
      defaultExpanded={isExpanded}
      onChange={(e, expanded) => setIsExpanded(expanded)}
      data-table-name={DATA_TABLE_NAME.CRA_TABLE}
    >
      <Container 
        onClick={(e) => e.stopPropagation()} 
        data-table-name={DATA_TABLE_NAME.CRA_TABLE}
        data-table-container="true"
      >
        {renderHeader()}
        {renderRows()}
      </Container>
    </Accordion>
  );
}
